module.exports = __webpack_public_path__ + "static/media/_isle-of-man.be38d2c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_isle-of-man.svg
// module id = 2329
// module chunks = 7